import { validAmount } from "../common-helpers";

export const sections = {
	income: [
		{
			sectionLabel: "Income (take-home)",
			data: [
				{label: "Jane's Paycheck", value: "$4,500", frequency: 12},
				{label: "Jane's Paycheck", value: "$3,000", frequency: 12},
			],
		}
	],
	expenses: [
		{
			sectionLabel: "Loans / Debt",
			data: [
				{label: "Mortgage / Rent", value: "$2,500", frequency: 12},
				{label: "Credit Card", value: "$1,000", frequency: 12},
				{label: "Home Equity Loan", value: "$0", frequency: 12},
				{label: "Car Loan", value: "$500", frequency: 12},
				{label: "Student Loan", value: "$0", frequency: 12},
			],
		},
		{
			sectionLabel: "Utilities",
			data: [
				{label: "Gas / Oil", value: "$0", frequency: 12},
				{label: "Electricity", value: "$0", frequency: 12},
				{label: "Telephone", value: "$0", frequency: 12},
				{label: "Water and Sewer", value: "$0", frequency: 12},
			],
		},
		{
			sectionLabel: "Insurance Premiums",
			data: [
				{label: "Life", value: "$0", frequency: 12},
				{label: "Auto", value: "$0", frequency: 12},
				{label: "Home", value: "$0", frequency: 12},
				{label: "Health", value: "$0", frequency: 12},
				{label: "Long Term Care", value: "$0", frequency: 12},
			],
		},
		{
			sectionLabel: "Savings and Investments",
			data: [
				{label: "Emergency Fund", value: "$0", frequency: 12},
				{label: "College Savings", value: "$0", frequency: 12},
				{label: "Retirement (IRA/etc.)", value: "$0", frequency: 12},
			],
		},
		{
			sectionLabel: "Miscellaneous",
			data: [
				{label: "Groceries", value: "$0", frequency: 12},
				{label: "Child Care", value: "$0", frequency: 12},
				{label: "Vacation", value: "$0", frequency: 12},
				{label: "Entertainment (movies/dining out/etc.)", value: "$0", frequency: 12},
				{label: "Clothing", value: "$0", frequency: 12},
				{label: "Gas (automobile)", value: "$0", frequency: 12},
				{label: "Commuting (parking/etc.)", value: "$0", frequency: 12},
				{label: "Charitable Contributions", value: "$0", frequency: 12},
				{label: "Out-of-Pocket Medical Expenses", value: "$0", frequency: 12},
			],
		},
	]
};

export  const periodOptions = [
	{ label: "1 Month", value: 1 },
	{ label: "2 Months", value: 2 },
	{ label: "3 Months", value: 3 },
	{ label: "4 Months", value: 4 },
	{ label: "5 Months", value: 5 },
	{ label: "6 Months", value: 6 },
	{ label: "7 Months", value: 7 },
	{ label: "8 Months", value: 8 },
	{ label: "9 Months", value: 9 },
	{ label: "10 Months", value: 10 },
	{ label: "11 Months", value: 11 },
	{ label: "12 Months", value: 12 },
];

export  const frequencyOptions = [
	{ label: "Daily", value: 260 },
	{ label: "Weekly", value: 52 },
	{ label: "BiWeekly", value: 26 },
	{ label: "Twice Monthly", value: 24 },
	{ label: "Monthly", value: 12 },
	{ label: "Quarterly", value: 4 },
	{ label: "Annually", value: 1 },
];

export type CalcRow = {
	label: string,
	value: string,
	frequency: number
};

export type CalcSection = {
	sectionLabel: string,
	data: {label: string, value: string, frequency: number}[]
};

export const getFrequencyLabel = (f: number) => {
	return frequencyOptions.filter(el => el.value === f)[0].label;
};

export const getBudgetPeriodLabel = (p: number) => {
	return periodOptions.filter(el => el.value === p)[0].label;
};

export const capitalize = (s: string) => (s && s[0].toUpperCase() + s.slice(1)) || "";

export	const calculateRowTotal = (row: CalcRow, totalPeriod: number) => {
	return Number(validAmount(row.value))*(row.frequency/12)*totalPeriod;
};

export const calculateCategory = (sections: CalcSection[], totalPeriod: number): number[] => {
	let categoryValueArray: number[] = [];
	sections.forEach(el => el.data.map(row => categoryValueArray.push(calculateRowTotal(row, totalPeriod))));
	return categoryValueArray;
};
